import axios from 'axios';
import Handlebars from 'handlebars';

export default function serverStatus() {
  axios.post('/clientarea.php', {
    action: 'getServerStatus'
  }).then(function (response) {
    if (response.data) {
      let status = response.data.priority;
      let type = 'success';
      let icon = 'smile';
      let template = document.getElementById('server-status-response').innerHTML;
      switch (status) {
        case 'Low':
          type = 'warning';
          icon = 'warning';
          break;
        case 'Critical':
        case 'High':
        case 'Medium':
          type = 'danger';
          icon = 'warning';
          break;
        default:
          type = 'success';
          icon = 'smile';
          response.data.title = 'Geen problemen';
      }
      let renderServerStatus = Handlebars.compile(template);

      response.data.status_type = type;
      response.data.status_icon = icon;

      document.getElementById('server-status').innerHTML = renderServerStatus(response.data);
    }
  }).catch(function (error) {
    console.log(error);
  });
}



// WEBPACK FOOTER //
// ./scripts/components/server_status.js